import React, { useContext, useEffect, useState, useRef } from 'react';
import { useMediaQuery } from 'react-responsive';
import { Scrollbars } from 'react-custom-scrollbars';
import Markup from '../../../../markup';
import { device } from '../../../../const/device';
import BuilderContext from '../../../../builder/hooks/context';
import find from 'lodash/find';
import filter from 'lodash/filter';
import SelectBox from '../../../Global/SelectBox';
import { trackBeforeUnload, trackSubStage } from '../../../../utils/Analytics';

function DesignPattern() {
  const { builder } = useContext(BuilderContext);

  const [selectedCategory, setSelectedCategory] = useState('All Patterns');
  const [rescatView, setRescatView] = useState(builder?.modelData?.patternList || []);
  const [atBottom, setAtBottom] = useState(false);
  const [atTop, setAtTop] = useState(true); 
  const ArrowColor = builder.membersData.colorTheme === "black" ? 'white' : 'black';
  const isTabletOrMobile = useMediaQuery({ query: `(${device.tablet})` });
  const caruselCat = [];
  const colCat = [];
  const scrollRef = useRef(null);

  const category = (value) => {
    let itr;
    let resCount = {};
    find(value, (item) => {
      if (itr === undefined) {
        caruselCat.push(item.pattern_category);
        itr = item.pattern_category;
      } else if (itr !== item.pattern_category) {
        itr = '';
        let findName = filter(caruselCat, (fv) => fv === item.pattern_category);
        if (findName.length === 0) {
          caruselCat.push(item.pattern_category);
        }
        itr = item.pattern_category;
        let checkName = filter(caruselCat, (vl) => vl === item.pattern_category);
        if (checkName.length === 1) {
          let resС = filter(value, (itm) => itm.pattern_category === itr);
          resCount[itr] = resС.length;
          colCat.push(resCount);
        }
      } else if (itr === item.pattern_category) {
        let res = filter(value, (itm) => itm.pattern_category === itr);
        if (Object.keys(resCount).length === 0) {
          resCount[itr] = res.length;
          colCat.push(resCount);
        } else if (resCount[itr] !== res.length) {
          resCount[itr] = res.length;
          colCat.push(resCount);
        }
      }
    });
    colCat.splice(1);
  };

  category(builder?.modelData?.patternList);

  const handleCategoryChange = (selected) => {
    setSelectedCategory(selected);
    if (selected === 'All Patterns') {
      setRescatView(builder?.modelData?.patternList || []);
    } else {
      const result = filter(builder?.modelData?.patternList, (cat) => cat.pattern_category === selected);
      setRescatView(result);
    }
  };

  useEffect(() => {
    trackSubStage('Design', 'Pattern');
    trackBeforeUnload('Pattern');
  }, []);

  useEffect(() => {
    if (selectedCategory === 'All Patterns' && builder?.modelData?.patternList) {
      setRescatView(builder?.modelData?.patternList);
    }
  }, [builder?.modelData?.patternList, selectedCategory]);
  

  const handleScroll = () => {
    if (scrollRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = scrollRef.current.getValues();
      setAtBottom(scrollTop + clientHeight >= scrollHeight - 1);
      setAtTop(scrollTop > 10);
    }
  };

  return (
    <Markup.Screen.Design.GridContainer>
      {isTabletOrMobile ? (
        <>
          <SelectBox items={['All Patterns', ...caruselCat]} 
              selected={selectedCategory} 
              setSelected={handleCategoryChange} 
              themeColor={builder.membersData.colorTheme} 
              isDesign={true}
          />
          {rescatView.map(item => (
            <Markup.Screen.Design.ItemPattern
              key={item.id}
              onClick={() => builder.modelData.setPattern(item.id)}
              active={builder.modelData.pattern === item.id}
              preview={item.preview}
            />
          ))}
        </>
      ) : (
        <>
          <SelectBox items={['All Patterns', ...caruselCat]} 
              selected={selectedCategory} 
              setSelected={handleCategoryChange} 
              themeColor={builder.membersData.colorTheme} 
              isDesign={true}
          />
          <Scrollbars
            ref={scrollRef}
            onScroll={handleScroll}
            autoHide
            autoHideTimeout={1000}
            autoHideDuration={200}
            renderTrackVertical={({ style, ...props }) => (
              <div
                {...props}
                style={{
                  ...style,
                  width: 4,
                  right: 0,
                  bottom: 2,
                  top: 2,
                  borderRadius: 3,
                }}
              />
            )}
          >
            {rescatView.map(item => (
              <Markup.Screen.Design.ItemPattern
                key={item.id}
                onClick={() => builder.modelData.setPattern(item.id)}
                active={builder.modelData.pattern === item.id}
                preview={item.preview}
              />
            ))}
            
          </Scrollbars>
          {!atBottom && ArrowColor === "black" && <Markup.Screen.Design.BottomMaskOpacity theme={builder.membersData.colorTheme[0]} />}
          {atTop && <Markup.Screen.Design.TopMaskOpacity theme={builder.membersData.colorTheme[0]}/>}
        </>
      )}
    </Markup.Screen.Design.GridContainer>
  );
}

export default React.memo(DesignPattern);
